import { Observable, catchError, noop, tap } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '../environments/environment';
import { TicketCountByStatus, TicketReplay, TicketSystem, } from '../models/interfaces/tieckets-system';
import { IResponse } from '../models/interfaces/response.model';
import { SideMenuService } from './../../admin/src/app/components/layout/side-menu/services/side-menu.service';
@Injectable({
  providedIn: 'root',
})
export class TicketSystemService {

  url = env.apiUrl + 'tickets';
  constructor(
    private http: HttpClient,
    private sideMenuService: SideMenuService
  ) {

  }
  createTickets(ticket: TicketSystem): Observable<TicketSystem> {
    return this.http.post<TicketSystem>(`${this.url}`, ticket, {
      withCredentials: true,
    });
  }

  // for admin
  getTickets(param: {} = {}): Observable<IResponse<TicketSystem>> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<IResponse<TicketSystem>>(`${this.url}?${params}`, {
      withCredentials: true,
    });
  }
  getTicket(id: any): Observable<TicketSystem> {
    return this.http.get<TicketSystem>(`${this.url}/${id}`, {
      withCredentials: true,
    });
  }
  // for user
  userTickets(param: {} = {}): Observable<IResponse<TicketSystem>> {
    const params = new HttpParams({ fromObject: param })
    return this.http.get<IResponse<TicketSystem>>(
      `${this.url}/user-tickets?${params}`,
      { withCredentials: true }
    );
  }
  userTicket(id: string): Observable<TicketSystem> {
    return this.http
      .get<TicketSystem>(`${this.url}/user-tickets/${id}`, {
        withCredentials: true,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }
  // admin and user
  deleteTicket(id: any): Observable<TicketSystem> {
    return this.http.delete<TicketSystem>(`${this.url}/${id}`, {
      withCredentials: true,
    });
  }
  closeTicket(ticketId: string): Observable<TicketSystem> {
    return this.http.patch<TicketSystem>(
      `${this.url}/close-ticket/${ticketId}`,
      {},
      { withCredentials: true }
    );
  }
  closeAdminTicket(ticketId: string): Observable<TicketSystem> {
    return this.http.patch<TicketSystem>(
      `${this.url}/change-ticket-status/${ticketId}?status=Closed`,
      {},
      { withCredentials: true }
    );
  }

  replyTicket(ticketId: string, replay: any): Observable<TicketReplay> {
    return this.http.post<TicketReplay>(
      `${this.url}/admin/add-ticket-reply/${ticketId}`,
      replay,
      { withCredentials: true }
    );
  }
  replyUserTicket(ticketId: string, replay: any): Observable<TicketReplay> {
    return this.http.post<TicketReplay>(
      `${this.url}/add-ticket-reply/${ticketId}`,
      replay,
      { withCredentials: true }
    );
  }

  getTicketReplies(ticketId: string, query = ''): Observable<TicketReplay[]> {
    return this.http.get<TicketReplay[]>(
      `${this.url}/ticket-replies/${ticketId}${query}`,
      { withCredentials: true }
    );
  }

  updateTicketReply(replayId: string, newReplay: TicketReplay): Observable<TicketReplay> {
    return this.http.patch<TicketReplay>(
      `${this.url}//update-ticket-reply//${replayId}`,
      newReplay,
      { withCredentials: true }
    );
  }

  changeTicketStatus(id: any, statusQuery = ''): Observable<TicketSystem> {
    return this.http.patch<TicketSystem>(
      `${this.url}/change-ticket-status/${id}${statusQuery}`,
      { withCredentials: true }
    );
  }

  countByStatus(): Observable<TicketCountByStatus> {
    return this.http.get<TicketCountByStatus>(`${this.url}/count-by-status`, { withCredentials: true });
  }

  getCountByStatus() {
    this.countByStatus().pipe( tap(
      counts => {
        this.sideMenuService.ticketCount_BS.next(counts.open);
      }
    )).subscribe( noop );
  }

}
